import Challenges from './Challenges';

export default Challenges;
